import Img from "./img";

const Palms = () => {
	const layers = [[], [], []];
	const LAYER_1 = [10, 4, 9, "1-1"];
	const LAYER_2 = ["2-2", 5, "10-3", "9-2"];
	const IMG_NUMS = [
		1, 1, 2, 2, 4, 4, 5,
		//6,
		// 7,
		9, 9, 10, 10, 10,
	];
	const IMG_CLASS_SUFFIX = [
		1,
		"1-1",
		2,
		"2-2",
		4,
		"4-2",
		5,
		// 6,
		// 7,
		9,
		"9-2",
		10,
		"10-2",
		"10-3",
	];
	for (let i = 0; i < IMG_NUMS.length; i++) {
		const j = IMG_NUMS[i];
		const c = IMG_CLASS_SUFFIX[i];
		const img = (
			<Img
				src={`/images/svg/palms/palm${j}.svg`}
				className={`palm palm-${c}`}
				loading="lazy"
				role="presentation"
				alt="Palm Leaf"
				key={i}
			/>
		);
		if (LAYER_1.includes(c)) layers[1].push(img);
		else if (LAYER_2.includes(c)) layers[2].push(img);
		else layers[0].push(img);
	}
	return (
		<>
			<div className="palms">{layers[0]}</div>
			<div className="palms-overlap">{layers[1]}</div>
			<div className="palms-overlap-2">{layers[2]}</div>
		</>
	);
};

export const MobilePalms = () => {
	return (
		<div className="mobile-palms">
			<Img
				src={`/images/svg/palms/palm2.svg`}
				className={`palm palm-1`}
				loading="lazy"
				role="presentation"
				alt="Palm Leaf"
			/>
			<Img
				src={`/images/svg/palms/palm1.svg`}
				className={`palm palm-2`}
				loading="lazy"
				role="presentation"
				alt="Palm Leaf"
			/>
		</div>
	);
};

export default Palms;
